export const ALREADY_RELOADED_FLAG_STORAGE_KEY = 'reloaded-on-chunkloaderror'
export const ALREADY_RELOADED_FLAG_UP_VALUE = 'true'
export const CHUNK_LOAD_ERROR_NAME = 'ChunkLoadError'
